import React from "react";
import { X } from "lucide-react";
import { useApp } from "../context/AppContext";
import { getYouTubeId } from "../utils/youtube";

export default function VideoPlayerModal() {
  const { activeVideo, setActiveVideo } = useApp();
  if (!activeVideo) return null;

  const vid = getYouTubeId(activeVideo.youtubeId);

  return (
    <div className="fixed inset-0 z-[60] flex items-center justify-center p-4">
      <div className="absolute inset-0 bg-black/85 backdrop-blur-sm" onClick={() => setActiveVideo(null)} />
      <div className="relative z-10 w-full max-w-[460px]">
        <div className="flex items-center justify-between mb-2">
          <p className="text-[13px] font-medium text-white/90 truncate pr-3">{activeVideo.title}</p>
          <button onClick={() => setActiveVideo(null)} className="w-8 h-8 rounded-full bg-white/10 flex items-center justify-center hover:bg-white/20">
            <X size={16} />
          </button>
        </div>
        <div className="relative aspect-video rounded-xl overflow-hidden bg-black">
          <iframe
            className="absolute inset-0 w-full h-full"
            src={`https://www.youtube.com/embed/${vid}?autoplay=1&rel=0`}
            title={activeVideo.title}
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          />
        </div>
      </div>
    </div>
  );
}
